<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentAppUrl /> 
</template>

<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'
import SideMenu from '@/components/worker/dashboard/SideMenu.vue'
import ContentAppUrl from '@/components/worker/dashboard/modules/report/appurl/ContentAppUrl.vue'

export default 
{
  name: 'AppUrl',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentAppUrl
  }
}
</script>

<style>


</style>